import React, { useEffect, useState } from 'react';
import { getListBlog } from '../../service/blogService';
import ReactHtmlParser from 'react-html-parser';

const Blog1 = () => {
    var [dataItems, setdataItems] = useState([]);
    useEffect(() => {
        try {
            getListBlog().then((response) => {
                if (response !== null) {
                    setdataItems(response);
                }

            });
        } catch (err) {
            setdataItems([])
            console.error(err);
        }
    }, []
    );
    if (dataItems.length > 0) {
        dataItems.splice(4, dataItems.length);
        return (
            <div className="page__post">
                <div className="container m-auto p-0">
                    <div className="row row--maint m-0">
                        <div className="col-12 px-0">
                            <div className="maint__title">
                                <div className="row m-0">
                                    <div className="maint__title--left col-3 px-0">
                                        <h2 className="float-start fw-bold ">Bài viết</h2>
                                    </div>
                                    <div className="maint__title--right col-8 px-0"></div>
                                    <div className="maint__title--right col-1 px-0">
                                    
                                    <div className="float-end position-relative"><a href="/camnang/">Xem tất cả</a> <i className="fa-solid fa-chevron-right"></i>
                                    </div>
                                    
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 p-0">
                            <div className="mant__item">
                                <div className="row m-0 position-relative box-blog">
                                {
                                    dataItems.map((item, index)=>{
                                        return(
                                            <div  key={index}  className="col-3 p-0">
                                                <div className="page__post--content bg-white">
                                                    <a href={item?.link?.replace('camnang.bibomart.com.vn','bibomart.com.vn/camnang')}>
                                                        <div className="page__post--content--show">
                                                            <div className="w-100 h-100">
                                                                <img className="w-100 h-100 rounded-3 " src={item?.featured_image_url} alt={item?.title.rendered}/></div>
                                                        </div>
                                                        <div className="page__post--content--info">
                                                            <div className="name fw-semibold my-2">{item?.title.rendered}</div>
                                                            <div className="name--custorm">{ReactHtmlParser(item?.content.rendered.substring(0,150)+'...')}</div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        )
    } else { return (<></>) }

}
export default Blog1
